import { env } from 'common/utils/env'

export const TEAM_EVENTS = {
  MESSAGE_SENT: 'team.message.sent',
  REQUEST_CHANGED: 'team.request.changed',
} as const

export const TEAM_AUTH_PATH = '/team/broadcasting/auth'

// Team chat broadcasts through the central Pusher app.
export const TEAM_PUSHER = {
  get key() {
    return env.PUSHER_KEY_CENTRAL
  },
  get cluster() {
    return env.PUSHER_CLUSTER_CENTRAL
  },
}
